// extracted by mini-css-extract-plugin
export var notificationHost = "_li-0";